import React from 'react'
import { Button } from '@s4l/ds'
import { IconClose } from '@s4l/icons/IconClose'

interface IActionRemoveProps {
  onClick: () => void
}

export const ActionRemove = ({ onClick }: IActionRemoveProps) => {
  return (
    <Button
      variant="icon-rounded"
      leadingIcon={<IconClose />}
      size="extraSmall"
      data-testid="remove-button"
      onClick={onClick}
      onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
    />
  )
}
ActionRemove.displayName = 'ActionRemove'
